import { ObservableContextBase } from './base/implementation';
import { AllowObservableContextBaseConstruct } from './base/constructor';
import { ObservableEmitAll } from '../functions';
import { OBSERVABLE_CONTEXT_BASE_PRIVATE } from './base/privates';
export function NewObservableContext(observable) {
    AllowObservableContextBaseConstruct(true);
    const context = new ObservableContext(observable);
    AllowObservableContextBaseConstruct(false);
    return context;
}
export function ObservableContextEmit(instance, value) {
    ObservableEmitAll(instance[OBSERVABLE_CONTEXT_BASE_PRIVATE].observable, value);
}
export class ObservableContext extends ObservableContextBase {
    constructor(observable) {
        super(observable);
    }
    emit(value) {
        ObservableContextEmit(this, value);
    }
}
//# sourceMappingURL=implementation.js.map